<!--TODO: hier sind verschiedene Komponenten enthalten. Der Name der Datei lautet Personal Data Input. Jedoch sind auch noch andere Komponenten enthalten-->
<template>
  <div class="app-activation-personal-data-input">
    <div class="form-wrapper">
      <slot name="beforeFormTxt">
        <h1>SIM-Karte aktivieren</h1>
        <p>Geben Sie hier Ihre persönlichen Daten ein. Diese werden SSL-verschlüsselt übertragen und sind nicht für Dritte einsehbar.</p>
        <div class="web-ident-info">
          <p><strong>Persönliche Daten</strong><br>Seit Juli 2017 gilt für <strong>alle</strong> Telekommunikationsanbieter ein neues Gesetz zur eindeutigen Identitätsprüfung bei Prepaid-Karten. Die&nbsp;SIM-Karten Aktivierung erfolgt nur nach erfolgreicher persönlicher Identifikation.</p>
          <p><strong>Bitte beachten Sie:</strong> Die hier eingegebenen Daten müssen exakt mit denen Ihres Ausweisdokuments übereinstimmen.</p></div>
      </slot>
      <b-form
        class="personal-data-input-form"
        :id="'form' + _uid"
        :novalidate="true"
        data-form-activation-personal-data-input>
        <b-form-group class="gender-group">
          <b-row>
            <b-col md="" sm="12">
              <label class="mandatory d-inline-block"><slot name="genderLabel">Anrede</slot></label>
            </b-col>
            <b-col md="" sm="12">
              <b-form-radio-group v-model="person.gender" required
                                  @input="$v.person.gender.$touch"
                                  :state="isValid('gender', 'person')">
                <b-form-radio name="gender" value="FEMALE">Frau</b-form-radio>
                <b-form-radio name="gender" value="MALE">Herr</b-form-radio>
              </b-form-radio-group>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group class="first-name-group">
          <b-row>
            <b-col md="" sm="12">
              <label class="mandatory d-inline-block"><slot name="firstNameLabel">Vorname</slot></label>
            </b-col>
            <b-col md="" sm="12">
              <b-form-input
                name="firstName"
                type="text"
                v-model="person.firstName"
                required
                @input="$v.person.firstName.$touch"
                :state="isValid('firstName', 'person')">
              </b-form-input>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group class="last-name-group">
          <b-row>
            <b-col md="" sm="12">
              <label class="mandatory d-inline-block"><slot name="lastNameLabel">Nachname</slot></label>
            </b-col>
            <b-col md="" sm="12">
              <b-form-input
                name="lastName"
                type="text"
                v-model="person.lastName"
                required
                @input="$v.person.lastName.$touch"
                :state="isValid('lastName', 'person')"
              ></b-form-input>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group class="street-group">
          <b-row>
            <b-col md="" sm="12">
              <label class="mandatory d-inline-block"><slot name="streetLabel">Strasse / Hausnummer</slot></label>
            </b-col>
            <b-col md="" sm="12">
              <b-form-input
                name="street"
                type="text"
                v-model="address.street"
                required
                @input="$v.address.street.$touch"
                :state="isValid('street', 'address')"
              ></b-form-input>
            </b-col>
            <b-col md="" sm="12">
              <b-form-input
                name="houseNumber"
                type="text"
                v-model="address.houseNumber"
                required
                @input="$v.address.houseNumber.$touch"
                :state="isValid('houseNumber', 'address')"
              ></b-form-input>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group class="supplement-group">
          <b-row>
            <b-col md="" sm="12">
              <label class="d-inline-block"><slot name="supplementLabel">Adresszusatz</slot></label>
            </b-col>
            <b-col md="" sm="12">
              <b-form-input
                name="supplement"
                type="text"
                v-model="address.supplement"
              ></b-form-input>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group class="zip-group">
          <b-row>
            <b-col md="" sm="12">
              <label class="mandatory d-inline-block"><slot name="zipLabel">PLZ / Ort</slot></label>
            </b-col>
            <b-col md="" sm="12">
              <b-form-input
                name="zip"
                type="text"
                v-model.trim="address.zip"
                required
                @input="$v.address.zip.$touch"
                :state="isValid('zip', 'address')"
              ></b-form-input>
            </b-col>
            <b-col md="" sm="12">
              <b-form-input
                name="city"
                type="text"
                v-model="address.city"
                required
                @input="$v.address.city.$touch"
                :state="isValid('city', 'address')"
              ></b-form-input>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group class="birth-date-group">
          <b-row>
            <b-col md="" sm="12">
              <label class="mandatory"><slot name="birthDateLabel">Geburtsdatum</slot></label>
            </b-col>
            <b-col>
              <b-input-group class="mb-3">
                <b-form-input
                  :id="'birthdate' + _uid"
                  type="text"
                  name="birthDate"
                  v-model="person.birthDate"
                  required
                  @input="$v.person.birthDate.$touch"
                  :state="isValid('birthDate', 'person')"
                  placeholder="TT.MM.JJJJ"
                  autocomplete="off"
                  aria-describedby="birthdate-live-feedback"
                ></b-form-input>
                <b-input-group-append>
                  <b-form-datepicker
                    v-bind="calendarSettings || {}"
                    button-only
                    right
                    required
                    @input="$v.person.birthDate.$touch"
                    :state="isValid('birthDate', 'person')"
                    :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                    @context="selectDate"
                    :aria-controls="'birthdate' + _uid"
                  ></b-form-datepicker>
                </b-input-group-append>
                <b-form-invalid-feedback id="birthdate-live-feedback">
                  <dyn-slot v-if="$v.person.birthDate.minAge === false" :slot-data="slotData"><slot name="birthdateAgeLiveFeedback">Für die Aktivierung müssen Sie mindestens {{ alowedMinAge }} Jahre alt sein<br></slot></dyn-slot>
                  <slot v-if="$v.person.birthDate.validDateFormat === false" name="birthdateFormatLiveFeedback">Ungültiges Format. Bitte wie folgt eingeben: TT.MM.JJJJ</slot>
                  <slot v-if="$v.person.birthDate.birthDateYoungTariffValidation === false" name="birthdateFormatLiveFeedback">Für die Aktivierung dürfen Sie nicht älter als 28 Jahre alt sein</slot>
                </b-form-invalid-feedback>
              </b-input-group>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group class="email-group">
          <b-row>
            <b-col md="" sm="12">
              <label class="mandatory d-inline-block"><slot name="emailLabel">E-Mail-Adresse</slot></label>
            </b-col>
            <b-col md="" sm="12">
              <b-form-input
                name="email"
                type="email"
                required
                @input="$v.additional.email.$touch"
                :state="isValid('email', 'additional')"
                v-model="additional.email"
              ></b-form-input>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group class="email-repeat-group">
          <b-row>
            <b-col md="" sm="12">
              <label class="mandatory d-inline-block"><slot name="emailRepeatLabel">E-Mail-Adresse wiederholen</slot></label>
            </b-col>
            <b-col md="" sm="12">
              <b-form-input
                name="email-repeat"
                type="email"
                required
                @input="$v.emailRepeat.$touch"
                :state="isValid('emailRepeat')"
                v-model="emailRepeat"
                aria-describedby="email-repeat-live-feedback"
              ></b-form-input>
              <slot name="emailRepeatIndication"></slot>
              <b-form-invalid-feedback id="email-repeat-live-feedback">
                <slot v-if="$v.emailRepeat.sameAsEmail === false" name="emailRepeatLiveFeedback">
                  E-Mail-Adresse nicht identisch
                </slot>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group class="password-group">
          <b-row>
            <b-col md="" sm="12">
              <label class="mandatory d-inline-block"><slot name="passwordLabelTxt">Passwort</slot></label>
            </b-col>
            <b-col md="" sm="12">
              <b-form-input
                name="password"
                type="password"
                required
                @input="$v.additional.password.$touch"
                :state="isValid('password', 'additional')"
                v-model="additional.password"
              ></b-form-input>
              <dyn-slot :slot-data="slotData"><slot name="passwordIndication"></slot></dyn-slot>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group class="password-repeat-group">
          <b-row>
            <b-col md="" sm="12">
              <label class="mandatory d-inline-block"><slot name="passwordRepeatLabelTxt">Passwort wiederholen</slot></label>
            </b-col>
            <b-col md="" sm="12">
              <b-form-input
                name="password-repeat"
                type="password"
                required
                @input="$v.passwordRepeat.$touch"
                :state="isValid('passwordRepeat')"
                v-model="passwordRepeat"
                aria-describedby="password-repeat-live-feedback"
              ></b-form-input>
              <b-form-invalid-feedback id="password-repeat-live-feedback">
                <slot v-if="$v.passwordRepeat.sameAsEmail === false" name="passwordRepeatLiveFeedback">
                  Passwort nicht identisch
                </slot>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
        </b-form-group>
        <ActivationPrivilegeTerms></ActivationPrivilegeTerms>
        <slot name="beforeIdentTxt">
          <h5>Ident-Verfahren wählen</h5>
          <p>Geben Sie Ihre Staatsangehörigkeit und Ihren Ausweistyp an und wählen sie ihre bevorzugte Art der Identifikation</p>
        </slot>
        <ActivationCountryInput
          :data-match-ident.sync="identInformation.dataMatchIdent"
          :default-ident-card-key="identInformation.identCard.key"
          :default-nationality-key="identInformation.nationality.iso3"
          :ident-card.sync="identInformation.identCard"
          :nationality.sync="identInformation.nationality"
          :ident-type.sync="identInformation.identType"
          :invalid.sync="identInvalid"
          @validation="checkFormValidation"
        >
          <template #noIdentificationPossibleTxt><slot name="countryInputNoIdentificationPossibleTxt"></slot></template>
          <template #postidentLabelTxt><slot name="countryInputPostidentLabelTxt"></slot></template>
          <template #videoidentLabelTxt><slot name="countryInputVideoidentLabelTxt"></slot></template>
          <template #nationalityLabel><slot name="countryInputNationalityLabelTxt"></slot></template>
          <template #identCardLabel><slot name="countryInputIdentCardLabelTxt"></slot></template>
          <template #dataMatchIdentLabelTxt><slot name="countryInputDataMatchIdentLabelTxt">
            <p>Meine angegebenen Daten stimmen mit denen meines Ausweisdokuments überein.</p>
          </slot></template>

        </ActivationCountryInput>
      </b-form>
      <slot name="alternativeTelRegistrationTxt">
      </slot>
    </div>
    <FriendNotification
      :msisdn.sync="friendMsisdn"
      :process-name="'activation'"
    >
      <template v-for="slot in possibleChildSlotsFor('Friend')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </FriendNotification>
    <VideoIdentificationModal>
      <template v-for="slot in possibleChildSlotsFor('VideoIdent')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </VideoIdentificationModal>
    <Stepper
      @prev="back()"
      @next="save()"
      :loading-next="loading"
      :disabled-next="$v.$invalid || loading"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>
import { BForm, BFormGroup, BFormInput } from 'bootstrap-vue'
import { required, sameAs, email } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import { validDate, validDateFormat, validGivenAge } from '@/validators/date'
import { validZipCode, validCityString } from '@/validators/address'
import ActivationCountryInput from '../../../generic/IdentMethod/InputCountryData.vue'
import VideoIdentificationModal from '../../../generic/IdentMethod/VideoIdentificationModal.vue'
import ActivationPrivilegeTerms from '../Summary/PrivilegeTerms.vue'
import processSteps from '@/mixins/processSteps'
import { stepName as previousProcessStep } from '../Info/ActivationInfo.vue' // naming with "Process" to avoid naming conflict with props "previousStep"
import { stepName as nextProcessStep } from '../Tariff/TariffOptions.vue'
import isValid from '@/mixins/isValid'
import slotProxy from '@/mixins/slotProxy'
import Stepper from '@/components/generic/Stepper.vue'
import preFilledInput from '@/mixins/preFilledInput'
import preFilledObjectInput from '@/mixins/preFilledObjectInput'

const initialValues = {
  identInformation: {
    nationality: {},
    identCard: {},
    identType: 'video',
    dataMatchIdent: false
  },
  address: {
    street: '',
    houseNumber: '',
    zip: '',
    city: '',
    supplement: ''
  },
  person: {
    gender: '',
    firstName: '',
    lastName: '',
    birthDate: null
  },
  additional: {
    email: '',
    password: ''
  }
}
export const stepName = 'personalDataInput'
export default {
  name: 'ActivationPersonalDataInput',
  data () {
    return {
      brand_: null,
      identInvalid: true,
      displayErrorMessage: false,
      loading: false
    }
  },
  created () {
    this.brand_ = this.brand
  },
  components: {
    BFormGroup,
    BFormInput,
    BForm,
    ActivationCountryInput,
    VideoIdentificationModal,
    ActivationPrivilegeTerms,
    Stepper
  },
  methods: {
    ...mapMutations('activation', [
      'goToStep'
    ]),
    ...mapActions('activation/personalData', [
      'validate'
    ]),
    back () {
      this.goToStep(this.previousStep)
    },
    save () {
      this.loading = true
      this.validate({
        person: this.person,
        address: this.address,
        additional: this.additional,
        identInformation: this.identInformation,
        friendMsisdn: this.friendMsisdn,
        nextStep: this.nextStep
      })
        .then(() => {
          this.loading = false
        }, () => {
          this.loading = false
        })
    },
    selectDate (ctx) {
      if (ctx.selectedDate) {
        this.person.birthDate = ctx.selectedFormatted
      }
    },
    checkFormValidation () {
      this.$v.$touch()
    }
  },
  computed: {
    slotData () {
      return {
        alowedMinAge: this.alowedMinAge
      }
    },
    ...mapGetters('activation/personalData', {
      storedPerson: 'personal',
      storedAddress: 'address',
      storedAdditional: 'additional',
      storedIdentification: 'identificationFull'
    }),
    ...mapGetters('friendNotification', {
      storedFriendMsisdn: 'existingCustomerMsisdn'
    }),
    ...mapGetters('activation/tariff', [
      'savedTariff'
    ]),
    ...mapGetters([
      'brand'
    ]),
    getPerson () {
      return { ...initialValues.person, ...this.storedPerson }
    },
    getAddress () {
      return { ...initialValues.address, ...this.storedAddress }
    },
    getAdditional () {
      return { ...initialValues.additional, ...this.storedAdditional }
    },
    getIdentification () {
      return { ...initialValues.identInformation, ...this.storedIdentification }
    },
    calendarSettings () {
      return this.$config.calendar.calendarSettings
    }
  },
  props: {
    alowedMinAge: {
      type: Number,
      default: 18
    }
  },
  mixins: [
    validationMixin,
    isValid,
    slotProxy(['Stepper']),
    processSteps(stepName, previousProcessStep, nextProcessStep),
    preFilledObjectInput('person', 'getPerson'),
    preFilledObjectInput('address', 'getAddress'),
    preFilledObjectInput('additional', 'getAdditional'),
    preFilledObjectInput('identInformation', 'getIdentification'),
    preFilledInput('friendMsisdn', 'storedFriendMsisdn'),
    preFilledInput('emailRepeat', function () {
      return this.storedAdditional?.email || ''
    }),
    preFilledInput('passwordRepeat', function () {
      return this.storedAdditional?.password || ''
    })
  ],
  validations () {
    const vm = this
    return {
      person: {
        gender: {
          required
        },
        firstName: {
          required
        },
        lastName: {
          required
        },
        birthDate: {
          validDate,
          validDateFormat,
          minAge (v) {
            return validGivenAge(v, vm.alowedMinAge)
          },
          birthDateYoungTariffValidation: this.$config?.validation?.validateYoungTariffBirthdate ? this.$config?.validation?.validateYoungTariffBirthdate(vm) : (birthdate) => true,
          required
        }
      },
      additional: {
        email: {
          required,
          email
        },
        password: {
          required,
          passwordValidation: this.$config.validation.validatePassword // also test length
        }
      },
      address: {
        street: {
          required
        },
        houseNumber: {
          required
        },
        zip: {
          validZipCode,
          required
        },
        city: {
          validCityString,
          required
        }
      },
      identInvalid: {
        sameAs: sameAs(() => false)
      },
      emailRepeat: {
        required,
        email,
        sameAsEmail: sameAs(function () {
          return this.additional.email
        })
      },
      passwordRepeat: {
        required,
        sameAsEmail: sameAs(function () {
          return this.additional.password
        })
      }
    }
  }
}
</script>
